import PropTypes from 'prop-types';

import { Box, Checkbox } from '@mui/material';

const Switch = ({ value, isDisabled, onChange, id, data, props }) => (
  <Box display="flex" justifyContent="center">
    <Checkbox
      checked={value}
      color="primary"
      size="medium"
      disabled={isDisabled}
      onClick={() => onChange(!value, id, data, props)}
    />
  </Box>
);

Switch.defaultProps = {
  isDisabled: false,
  onChange: () => {},
  id: null,
  data: null,
  props: null,
};

Switch.propTypes = {
  value: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  data: PropTypes.instanceOf(Object),
  props: PropTypes.instanceOf(Object),
};

export default Switch;
